module.exports = __webpack_public_path__ + "img/4_1.d91d7480.png";